import { render, staticRenderFns } from "./AddService.vue?vue&type=template&id=00889649&scoped=true"
import script from "./AddService.vue?vue&type=script&lang=js"
export * from "./AddService.vue?vue&type=script&lang=js"
import style0 from "./AddService.vue?vue&type=style&index=0&id=00889649&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00889649",
  null
  
)

export default component.exports